import { getBounds } from './getBounds';
/**
 * Fits the Google Map instance to the specified distance, center, and bounds.
 *
 * @param {object} options - The options for fitting the map to the markers.
 * @param {number} options.distance - The distance to fit the map to.
 * @param {object} options.center - The center coordinates of the map.
 * @param {object} options.map - The Google Map instance to fit to the markers.
 * @param {object} options.maps - The Google Maps API object.
 */
export const fitMapToMarkers = ({ distance, center, map, maps, }) => {
    const bounds = getBounds({
        distance,
        maps,
        center,
    });
    // fitBounds isn't always a "perfect" fit to given bounds.
    // it will find the nearest zoom level that shows the bounds within the viewport.
    map.fitBounds(bounds);
};
